<form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="form" class="dynamic-form-builder-wrapper">
  <div
    *ngFor="let section of fields?.sections"
    class="monetize-card fb-monetize-card dynamic-module-main-class"
  >
    <h2 *ngIf="section.title">{{ section.title }}</h2>
    <div class="row">
      <ng-container *ngFor="let field of section.fields">
        <div [ngClass]="field.class" *ngIf="isFieldVisible(field)">
          <ng-container [ngSwitch]="field.type">
            <ng-container *ngSwitchCase="fieldTypesEnum.TEXT">
              <app-input [field]="field" [form]="form"></app-input>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.NUMBER">
              <app-input [field]="field" [form]="form"></app-input>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.PASSWORD">
              <app-input [field]="field" [form]="form"></app-input>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.TEXT_AREA">
              <app-textarea [field]="field" [form]="form"></app-textarea>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.SELECT">
              <app-select [field]="field" [form]="form"></app-select>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.DATE_PICKER">
              <app-datepicker [field]="field" [form]="form"></app-datepicker>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.ADDRESS">
              <app-location-input
                [field]="field"
                [form]="form"
              ></app-location-input>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.CHECKBOX">
              <app-checkbox [form]="form" [field]="field"></app-checkbox>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.TIME_PICKER">
              <app-timepicker [field]="field" [form]="form"></app-timepicker>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.MULTI_SELECT">
              <app-multiselect [field]="field" [form]="form"></app-multiselect>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.FILE_UPLOAD_INPUT">
              <app-file-upload-input
                [field]="field"
                [form]="form"
              ></app-file-upload-input>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.FILE_UPLOAD_INPUT_V2">
              <app-file-upload-input-v2
                [field]="field"
                [form]="form"
              ></app-file-upload-input-v2>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.BANNER_IMAGE">
              <app-banner-image-upload
                [field]="field"
                [form]="form"
              ></app-banner-image-upload>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.VIDEO_UPLOAD">
              <app-video-upload
                [field]="field"
                [form]="form"
              ></app-video-upload>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.MULTIPLE_IMAGE">
              <app-multiple-image-upload
                [field]="field"
                [form]="form"
              ></app-multiple-image-upload>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.COLOR_PICKER">
              <app-form-color-picker
                [field]="field"
                [form]="form"
              ></app-form-color-picker>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.MOBILE_INPUT">
              <app-mobile-input
                [field]="field"
                [form]="form"
              ></app-mobile-input>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.BUTTON">
              <app-button
                [btnField]="field"
                [isEditMode]="isEditMode"
              ></app-button>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.RADIO">
              <app-radio-button
                [field]="field"
                [form]="form"
              ></app-radio-button>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.LABEL">
              <app-label [field]="field"></app-label>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.DISCLAIMER_MESSAGE">
              <app-disclaimer-message [field]="field"></app-disclaimer-message>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.CUSTOM_MULTISELECT">
              <app-custom-multiselect
                [field]="field"
                [form]="form"
              ></app-custom-multiselect>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.PROFILE_IMAGE">
              <app-profile-image-upload
                [field]="field"
                [form]="form"
              ></app-profile-image-upload>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.OPTION_LIST">
              <app-option-list [field]="field" [formControlName]="field.name"></app-option-list>
            </ng-container>
            <ng-container *ngSwitchCase="fieldTypesEnum.MAP_IFRAME">
              <div *ngIf="field.label" class="form-group mb-2">
                <label>{{ field.label }}</label>
              </div>
              <app-form-map-iframe
                [embedMapMode]="!(field.mapEmbedUrl != null && String(field.mapEmbedUrl).trim().length > 0)"
                [embedLocation]="field.mapEmbedLocation ?? undefined"
                [url]="field.mapEmbedUrl"
                [iframeId]="field.mapIframeHtmlId || (field.name ? 'map-iframe-' + field.name : 'map-iframe')"
                [heightPx]="field.mapIframeHeightPx ?? 450"
                [showRadius]="field.showRadius"
                (embedMapInteraction)="onSegmentEmbedMapInteraction($event, field?.name)"
              ></app-form-map-iframe>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-container *ngFor="let btn of fields?.buttons">
    <app-button [btnField]="btn" [isEditMode]="isEditMode"></app-button>
  </ng-container>
</form>
